import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Button, Card, ErrorText } from "../components/ui";
import { api } from "../services/api";

export function CancelReservation() {
  const { token } = useParams<{ token: string }>();
  const [ok, setOk] = useState(false);
  const [err, setErr] = useState("");

  const cancel = async () => {
    if (!token) return;
    setErr("");
    try {
      await api.delete(`/reservations/${token}`);
      setOk(true);
    } catch {
      setErr("Не удалось отменить бронь. Проверьте ссылку.");
    }
  };

  return (
    <>
      <Helmet>
        <title>Отмена брони — WishList Hub</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <Card className="max-w-md mx-auto text-center">
        {ok ? (
          <>
            <h1 className="text-xl font-semibold text-white">Бронь снята</h1>
            <Link to="/" className="mt-4 inline-block text-violet-400">
              На главную
            </Link>
          </>
        ) : (
          <>
            <h1 className="text-xl font-semibold text-white">Отменить бронирование?</h1>
            {err && <ErrorText>{err}</ErrorText>}
            <div className="mt-6 flex justify-center gap-2">
              <Button variant="danger" onClick={cancel}>
                Да, снять бронь
              </Button>
              <Link to="/">
                <Button variant="secondary">Нет</Button>
              </Link>
            </div>
          </>
        )}
      </Card>
    </>
  );
}
